package com.starparty.app.astro0

import kotlin.math.*


/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
object MathD {
    const val DEG_TO_RAD = PI / 180.0
    const val DEG_360 = 360.0
    const val DEG_180 = 180.0
    fun sinD(degrees: Double): Double {
        return sin(degrees * DEG_TO_RAD)
    }

    fun cosD(degrees: Double): Double {
        return cos(degrees * DEG_TO_RAD)
    }

    fun tanD(degrees: Double): Double {
        return tan(degrees * DEG_TO_RAD)
    }

    fun asinD(value: Double): Double {
       val radians = asin(value)

        return asin(value) / DEG_TO_RAD
    }

    fun acosD(value: Double): Double {
        return acos(value) / DEG_TO_RAD
    }

    fun atanD(value: Double): Double {
        return atan(value) / DEG_TO_RAD
    }

    fun atanD2(y: Double, x: Double): Double {
        var result = Double.NaN // undefined if both x and y are 0.
        if (x != 0.0) {
            result = atanD(y / x)
            if (x < 0) {
                result = if (y >= 0) {
                    result + DEG_180
                } else {
                    result - DEG_180
                }
            }
        } else { // x == 0
            if (y > 0) {
                result = 90.0
            }
            if (y < 0) {
                result = -90.0
            }
        }
        return result
    }

    fun equivalentAngleBetweenZeroAnd360(angle: Double): Double {
        var angle = angle
        while (angle > DEG_360) {
            angle = angle - 360
        }
        while (angle < 0) {
            angle = angle + 360
        }
        return angle
    }
}